import { useUserInfor } from "../../../../../../../Context/User";
import { GetConfigModuloController } from "../../../../../../../Controllers/Geral/ConfigGeral/ConfigGeralController";
import { AtualizarConfigGeralController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/ConfigGeral/ConfigGeralController";
import useAsyncEffect from "../../../../../../../hooks/useAsyncEffect";
import { IConfigGeralModulos } from "../../../../../../../Interfaces/Geral/ConfigGeral/ConfigGeral";

interface IRepasseConfig {
    lstConfigModulo: IConfigGeralModulos[] | undefined;
    AtualizarConfigModulo: (requestBody: IConfigGeralModulos) => Promise<any>;
    ListConfigModulo: (...args: any[]) => Promise<IConfigGeralModulos[]>;
}

export default function RepasseConfig(props: IRepasseConfig) {
    const { Config, updateConfig } = useUserInfor();
    const config = Config.ConfigAtendimentoDTO;

    const idModuloRepasse = props.lstConfigModulo?.find(
        (lst) => lst.ID_MODULO === 5
    );

    const { value: getConfigModulo } = useAsyncEffect(async () => {
        if (idModuloRepasse) {
            return GetConfigModuloController(idModuloRepasse.ID_MODULO);
        }
    }, [idModuloRepasse]);

    function update() {
        AtualizarConfigGeralController({
            ...Config,

            ConfigAtendimentoDTO: {
                ...config,
            },
        }).then(() => {
            updateConfig();
        });
    }

    return (
        <>
            <div className="col-12 mb-4">
                <h4>Avançar Etapa</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Salvar dados de repasse automaticamente ao avançar
                        etapa?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={config?.FL_AVANCAR_ETAPA_REPASSE}
                                    onChange={() => {
                                        config.FL_AVANCAR_ETAPA_REPASSE =
                                            !config.FL_AVANCAR_ETAPA_REPASSE;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Abrir novo atendimento</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Abrir novo atendimento ao receber resposta do cliente no
                        email de finalização do caso.
                    </label>
                    <div className="col-6">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        getConfigModulo?.ConfigModuloCampo
                                            .FL_CRIAR_ATEND_RESPOSTA_EMAIL
                                    }
                                    onChange={(e) => {
                                        props
                                            .AtualizarConfigModulo({
                                                ConfigModuloCampo: {
                                                    FL_CRIAR_ATEND_RESPOSTA_EMAIL:
                                                        Boolean(
                                                            e.target.checked
                                                        ),
                                                },
                                                ID_MODULO:
                                                    getConfigModulo?.ID_MODULO ??
                                                    0,
                                            })
                                            .then(() => {
                                                props.ListConfigModulo();
                                                updateConfig();
                                            });
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
}
